import Day from '@/components/icons/weather/day'
import DayAndNight from '@/components/icons/weather/day-and-night'
import Dry from '@/components/icons/weather/dry'
import Mixed from '@/components/icons/weather/mixed'
import Night from '@/components/icons/weather/night'
import Unknown from '@/components/icons/weather/unknown'
import Wet from '@/components/icons/weather/wet'

export const timeOfDayOptions = [
  {
    name: 'day',
    label: 'Day',
    icon: <Day className="size-5" />,
  },
  {
    name: 'night',
    label: 'Night',
    icon: <Night className="size-5" />,
  },
  {
    name: 'mixed',
    label: 'Day & Night',
    icon: <DayAndNight className="size-5" />,
  },
]

export const weatherOptions = [
  {
    name: 'dry',
    label: 'Dry',
    icon: <Dry className="size-5" />,
  },
  {
    name: 'wet',
    label: 'Wet',
    icon: <Wet className="size-5" />,
  },
  {
    name: 'mixed',
    label: 'Mixed',
    icon: <Mixed className="size-5" />,
  },
  {
    name: 'unknown',
    label: 'Unknown',
    icon: <Unknown className="size-5" />,
  },
]
